export default "__VITE_ASSET__DxtkglKw__"